import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { PersianTitlesService } from '../services/persian-titles.service'; // مسیر درست به سرویس

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private title: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private persianTitles: PersianTitlesService,
  ) {}

  init(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data),
      )
      .subscribe((data) => {
        const titleKey = data['titleKey'];
        if (titleKey && this.persianTitles.Items[titleKey]) {
          this.title.setTitle(
            'مدرسه مدیریتی افرا: آموزش تخصصی مدیریت خیریه و سازمان مردم نهاد' +
              ' | ' +
              this.persianTitles.Items[titleKey],
          );
        } else {
          this.title.setTitle(
            'مدرسه مدیریتی افرا: آموزش تخصصی مدیریت خیریه و سازمان مردم نهاد',
          );
        }
      });
  }
}
